import produce from 'immer';

import { STRATA_RECEIVED, STRATAS_RECEIVED } from 'constants/actions';

export var INITIAL_STATE = {
  items: [],
  strataError: false,
  stratasError: false
};

export const stratas = produce((draft, action) => {
  switch (action.type) {
    case STRATAS_RECEIVED:
      draft.items = action.value;
      return draft;

    case STRATA_RECEIVED: {
      let index = draft.items.findIndex(({ id }) => id === action.value.id);

      ~index ? (draft.items[index] = action.value) : draft.items.push(action.value);
      return draft;
    }

    default:
      return draft;
  }
}, INITIAL_STATE);

export default stratas;
